<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor"
          d="M0.818176 6.41636C0.818176 6.08809 0.985277 5.78153 1.26348 5.59944L8.99999 0L16.7365 5.59944C17.0147 5.78153 17.1818 6.08809 17.1818 6.41636V17.0182C17.1818 17.5604 16.7341 18 16.1818 18H12C11.4477 18 11 17.5604 11 17.0182V12.9273C11 12.385 10.5523 11.9455 9.99999 11.9455H7.99999C7.44771 11.9455 6.99999 12.385 6.99999 12.9273V17.0182C6.99999 17.5604 6.55228 18 5.99999 18H1.81818C1.26589 18 0.818176 17.5604 0.818176 17.0182V6.41636Z" />
  </svg>
</template>

<script>
export default {
  name: 'Home',
};
</script>
